import { render, staticRenderFns } from "./goal-details.vue?vue&type=template&id=2b2d16c9&scoped=true"
import script from "./goal-details.vue?vue&type=script&lang=js"
export * from "./goal-details.vue?vue&type=script&lang=js"
import style0 from "./goal-details.vue?vue&type=style&index=0&id=2b2d16c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2d16c9",
  null
  
)

export default component.exports